import { useCallback, useState } from 'react';
import { IRoomStreaming } from '../../../redux/streamGoApi';
import { ActionDialog } from '../../Form';
import { StreamingUrlForm } from './StreamingUrlForm';

export interface IStreamingUrlDialog {
  editingIndex: number | null;
  formData: IRoomStreaming;
  onCancel: () => void;
  onFieldChange: (field: keyof IRoomStreaming, value: string) => void;
  onSave: () => void;
  open: boolean;
}

export const StreamingUrlDialog = ({
  editingIndex,
  formData,
  onCancel,
  onFieldChange,
  onSave,
  open,
}: IStreamingUrlDialog) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleOnSave = useCallback(() => {
    setIsSubmitting(true);
    if (isFormValid) {
      onSave();
      setIsSubmitting(false);
    }
  }, [isFormValid, onSave]);

  return (
    <ActionDialog
      actionButtons={[
        {
          buttonText: editingIndex !== null ? 'Update' : 'Add',
          color: 'success',
          onClick: handleOnSave,
        },
      ]}
      onCancel={onCancel}
      open={open}
      title={editingIndex !== null ? 'Edit Streaming URL' : 'Add Streaming URL'}
    >
      <StreamingUrlForm
        formData={formData}
        isSubmitting={isSubmitting}
        onFieldChange={onFieldChange}
        onValidationChange={setIsFormValid}
      />
    </ActionDialog>
  );
};
